import { Box, Button, Icon, IconButton, Tooltip, Typography } from "@mui/material";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import InfoIcon from '@mui/icons-material/Info';
import { ExpandMore, ExpandLess, BorderBottom } from "@mui/icons-material";

export const DetailRow = ({ label, value, style, icon, className }) => (
  <Box display="flex" alignItems="center" mb={1} style={style} className={className}>
    {/* Icon on the left */}
    {icon && (
      <Box mr={2}>
        <Icon fontSize="medium" color="secondary">{icon}</Icon>
      </Box>
    )}

    {/* Label and value stacked vertically */}
    <Box>
      <MDTypography variant="caption" color="textSecondary" fontWeight="bold">
        {label}
      </MDTypography>
      <MDTypography variant="body2" fontWeight="light">
        {value || 'N/A'}
      </MDTypography>
    </Box>
  </Box>
);

export const SectionHeading = ({ title, isCollapsed, setIsCollapsed }) => {
  const headingStyle = {
    backgroundColor: "#e8e7e77a",
    color: "#333",
    padding: '12px 16px',      
    borderRadius: '6px',       
    display: 'flex',          
    justifyContent: 'space-between', 
    // alignItems: 'center',
    // textAlign: 'center',
    // alignItems: 'center',
    // BorderBottom: '4px solid #1976d2 !important',
  };

  const handleToggle = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <Box sx={headingStyle}
      variant="gradient"
      bgColor="info"
      borderRadius="lg"
      coloredShadow="info">
      {/* Title on the left */}
      <Box display="flex" alignItems="center">
        <Icon>info</Icon>
        <Typography ml={1} color="white" variant="h6">{title}</Typography>
      </Box>

      {/* Icon button at the right */}
      {isCollapsed !== undefined &&
        <IconButton
          variant="text"
          size="large"
          onClick={handleToggle}
          sx={{ textTransform: 'none', textAlign: 'right' }}
        >
          {isCollapsed ? <ExpandMore /> : <ExpandLess />}
        </IconButton>}
    </Box>
  );
};

export const InfoTooltip = ({ text }) => {
  return (
    <Tooltip title={text} arrow placement="top">
      <Box ml={1} display="flex" alignItems="center">
        <InfoIcon style={{ cursor: 'pointer' }} />
      </Box>
    </Tooltip>
  )
}
